import { Box, Button, Typography, getContrastRatio } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { updateState } from "../../../redux/commonSlice";
import { LoadingButton } from "@mui/lab";
import CustomAlert from "../../events/components/CustomAlert";
import useCustomTheme from "../../../theme/useCustomTheme";
import { generateLighterContrastColor } from "../../../utils/commonServices";

/**
 * Unlike DeleteConfirmationPopup this asks for no typed confirmation - archiving
 * changes nothing about the project and is undone in one click. The dialog's
 * job is to make the scope of the change clear.
 */
const ArchiveConfirmationPopup = (props) => {
  const { archiveProject, status } = props;
  const dispatch = useDispatch();
  const commonReducer = useSelector((state) => state.root.commonReducer);
  const [theme] = useCustomTheme();

  const handleClose = () => {
    dispatch(updateState({ archive_project_popup: false, archive_project_name: "", archive_project_id: null }));
  };

  const confirmHandler = () => {
    archiveProject(commonReducer.archive_project_id);
  };

  return (
    <CustomAlert
      open={commonReducer.archive_project_popup}
      handleClose={handleClose}
      width={{ xs: '400px', sm: '400px', md: '420px', lg: '440px', xl: '600px' }}
      height={{ xs: '250px', sm: '260px', md: '290px', lg: '300px', xl: '380px' }}
    >
      <Box p={5} className="flex col j-center" sx={{ height: '100%' }}>

        <Box mb={{ xs: 1, md: 2 }} mt={1}>
          <Typography variant="h4" sx={{ fontFamily: 'Rubik', fontSize: { xs: '13px', sm: '13px', md: '13px', lg: '13px', xl: '18px' }, color: 'black' }}>
            {`Archive "`}
            <Typography component='span' sx={{ fontFamily: 'Rubik', fontWeight: 600, fontSize: { xs: '13px', sm: '13px', md: '13px', lg: '13px', xl: '18px' }, color: 'black' }}>
              {commonReducer.archive_project_name}
            </Typography>
            {`" from your dashboard?`}
          </Typography>
        </Box>

        <Box>
          <Typography sx={{ fontFamily: 'Rubik', fontSize: { xs: '11px', sm: '11px', md: '11px', lg: '12px', xl: '15px' }, fontWeight: 300, color: '#333333' }}>
            Only your view changes - everyone else on the project still sees it, and it stays archived until you unarchive it. You can find it again under Archived Projects.
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', justifyContent: 'end' }} gap={2} mt={{ xs: 1, md: 2 }}>

          <Button
            variant='outlined'
            color="button"
            onClick={handleClose}
            disabled={status === 'loading'}
            style={{ borderRadius: '5px', color: theme.palette.primary.main === ('#00d744' || '#00D744') ? '#00d744' : getContrastRatio('#08231B', theme.palette.primary.main) > 4.5 ? `${theme.palette.primary.main}` : generateLighterContrastColor(theme.palette.primary.main), textTransform: 'none' }}
            sx={{ fontSize: { xs: '9px', sm: '9px', md: '9px', lg: '11px', xl: '16px' }, fontWeight: 600, width: { xs: '76px', sm: '76px', md: '76px', lg: '86px', xl: '129px' }, paddingY: 0.4 }}
          >Cancel</Button>

          <LoadingButton
            disabled={status === 'loading'}
            onClick={confirmHandler}
            style={{ borderRadius: '5px', backgroundColor: '#08231B', color: theme.palette.primary.main, textTransform: 'none' }}
            sx={{ fontSize: { xs: '9px', sm: '9px', md: '9px', lg: '11px', xl: '16px' }, fontWeight: 600, width: { xs: '76px', sm: '76px', md: '76px', lg: '86px', xl: '129px' }, minWidth: '110px !important' }}
            loading={status === 'loading'}
            loadingPosition="start"
            variant="contained"
          >
            Archive
          </LoadingButton>
        </Box>
      </Box>
    </CustomAlert>
  );
};

export default ArchiveConfirmationPopup;
